import React from 'react';

const Gallery = () => {
  const galleryItems = [
    {
      id: 1,
      title: "Skincare Products",
      category: "Foreign Skincare",
      image: "https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=600&h=800&fit=crop",
      gallery: "https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=1200&h=1600&fit=crop",
      description: "Premium foreign skincare products carefully selected for all skin types and concerns."
    },
    {
      id: 2,
      title: "Makeup Collection",
      category: "Professional Makeup",
      image: "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=600&h=800&fit=crop",
      gallery: "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=1200&h=1600&fit=crop",
      description: "High-quality makeup products for professional application and everyday beauty."
    },
    {
      id: 3,
      title: "Makeup Artistry",
      category: "Professional Service",
      image: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=600&h=800&fit=crop",
      gallery: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=1200&h=1600&fit=crop",
      description: "Expert makeup application for special events, photoshoots, and everyday glamour."
    },
    {
      id: 4,
      title: "Skincare Consultation",
      category: "Expert Analysis",
      image: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=600&h=800&fit=crop",
      gallery: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=1200&h=1600&fit=crop",
      description: "Personalized skincare consultation to address your unique skin needs and concerns."
    },
    {
      id: 5,
      title: "Makeup Training",
      category: "Beauty Education",
      image: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=600&h=800&fit=crop",
      gallery: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=1200&h=1600&fit=crop",
      description: "Learn professional makeup techniques with personalized guidance and hands-on training."
    },
    {
      id: 6,
      title: "Beauty Transformation",
      category: "Complete Makeover",
      image: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=600&h=800&fit=crop",
      gallery: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=1200&h=1600&fit=crop",
      description: "Complete beauty transformation combining skincare expertise and makeup artistry."
    }
  ];

  return (
    <section id="works" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">Our Services & Products.</h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {galleryItems.map((item) => (
            <div key={item.id} className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-lg bg-white shadow-lg hover:shadow-xl transition-shadow">
                <img 
                  src={item.image} 
                  alt={item.title}
                  className="w-full h-80 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="p-6">
                  <h4 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h4>
                  <div className="text-sm text-gray-500 mb-3">{item.category}</div>
                  <p className="text-gray-600 text-sm">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-lg p-8 shadow-lg">
          <h3 className="text-3xl font-bold text-center text-gray-900 mb-12">What Our Clients Say</h3>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <img 
                src="https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop&crop=face" 
                alt="Client" 
                className="w-16 h-16 rounded-full mx-auto mb-4"
              />
              <div className="mb-4">
                <strong className="text-gray-900">Adunni Okafor</strong>
                <div className="text-sm text-gray-500">Business Executive</div>
              </div>
              <p className="text-gray-600">
                KADIBIA BEAUTY transformed my skincare routine completely. The consultation was thorough 
                and the foreign products recommended have given me the best skin of my life!
              </p>
            </div>

            <div className="text-center">
              <img 
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face" 
                alt="Client" 
                className="w-16 h-16 rounded-full mx-auto mb-4"
              />
              <div className="mb-4">
                <strong className="text-gray-900">Funmi Adebayo</strong>
                <div className="text-sm text-gray-500">Bride</div>
              </div>
              <p className="text-gray-600">
                The makeup artistry for my wedding was absolutely stunning! The team guided me through 
                every step and I felt like a queen. Highly recommend their services!
              </p>
            </div>

            <div className="text-center">
              <img 
                src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face" 
                alt="Client" 
                className="w-16 h-16 rounded-full mx-auto mb-4"
              />
              <div className="mb-4">
                <strong className="text-gray-900">Chioma Nwankwo</strong>
                <div className="text-sm text-gray-500">Makeup Enthusiast</div>
              </div>
              <p className="text-gray-600">
                The makeup training sessions were incredible! I learned professional techniques and 
                now I can do my own makeup confidently. Thank you KADIBIA BEAUTY!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;